module.exports = __webpack_public_path__ + "fonts/Inter-500-latin38.5eb4a77.woff2";